import { render, staticRenderFns } from "./lkuCrewCollectorLazzy.vue?vue&type=template&id=38bd3ab4&"
import script from "./lkuCrewCollectorLazzy.vue?vue&type=script&lang=js&"
export * from "./lkuCrewCollectorLazzy.vue?vue&type=script&lang=js&"
import style0 from "./lkuCrewCollectorLazzy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports